module.exports = __webpack_public_path__ + "img/lim guan eng_mouth.83891dc0.jpg";